// src/pages/UploadPage.js
import React, { useState } from 'react';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // 05.09.25 18:15 AEST
import { storage, db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import './UploadPage.css';

const UploadPage = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
// 05.09.25 4:15pm - Always use live auth; no test fallback
const { currentUser } = useAuth();
// 05.09.25 18:15 AEST - Only for UI; path/email computed at click time
const displayEmail = (currentUser?.email || '').trim();

console.log('05.09.25 18:15 AEST - Current user debug:', {
  currentUser,
  displayEmail,
  isAuthenticated: !!currentUser
});
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
      setError(null);
      setSuccess(null);
    }
  };
  
  const handleUpload = async () => {
    if (!file) {
      setError("Please select a file first");
      return;
    }
  
    // 05.09.25 18:15 AEST - Re-read live auth at click time (avoids any stale context)
    const authEmail = (getAuth().currentUser?.email || currentUser?.email || '').trim();
    const emailKey = authEmail.toLowerCase();
  
    if (!authEmail) {
      setError("You're not signed in. Please sign out and sign back in.");
      return;
    }
  
    setLoading(true);
    setError(null);
    setSuccess(null);
    
    try {
      console.log('Starting upload for file:', file.name);
      console.log('05.09.25 18:15 AEST - Upload for:', authEmail);
      
      // Create a reference to the storage location
      const filePath = `Users/${emailKey}/uploads/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, filePath);
      console.log('Storage reference created:', filePath);
      
      // Upload file
      await uploadBytes(storageRef, file);
      console.log('File uploaded successfully');
      
      // Get download URL
      const downloadURL = await getDownloadURL(storageRef);
      console.log('Download URL:', downloadURL);
      
      // Save metadata to Firestore
      const docRef = await addDoc(
        collection(db, 'Users', emailKey, 'Files'),
        {
          fileName: file.name,
          contentType: file.type,
          fileSize: file.size,
          path: filePath,
          downloadURL,
          uploadedAt: serverTimestamp(),
          status: 'completed',
          category: 'Uncategorized',
          subCategory: 'Uncategorized'
        }
      );
      
      console.log('Metadata saved to Firestore:', docRef.id);
      setSuccess(`File uploaded successfully: ${file.name}`);
      setFile(null);
    } catch (error) {
      console.error('Upload error:', error);
      setError(`Upload failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="upload-page">
      <header className="page-header">
      {/* 27.11.25 19:00 AEDT - Updated header to production version */}
      <h1>Upload Documents</h1>
  <div style={{ fontSize: '12px', opacity: 0.8 }}>
  Signed in as: <strong>{displayEmail || '— not signed in —'}</strong>
  </div>
</header>
      
      <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
        <div style={{ marginBottom: '20px', border: '2px dashed #ddd', padding: '20px', textAlign: 'center' }}>
          <input 
            type="file" 
            onChange={handleFileChange} 
            disabled={loading}
            style={{ marginBottom: '20px' }}
          />
          
          {file && (
            <div style={{ 
              backgroundColor: '#f5f5f5', 
              padding: '10px', 
              borderRadius: '4px',
              marginBottom: '20px'
            }}>
              <p><strong>Selected file:</strong> {file.name}</p>
              <p><strong>Size:</strong> {Math.round(file.size / 1024)} KB</p>
            </div>
          )}
          
          <button 
            onClick={handleUpload} 
            disabled={!file || loading}
            style={{
              padding: '12px 24px',
              backgroundColor: file && !loading ? '#128C7E' : '#cccccc',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: file && !loading ? 'pointer' : 'not-allowed',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            {loading ? 'Uploading...' : 'Upload File'}
          </button>
        </div>
        
        {error && (
          <div style={{ 
            padding: '10px', 
            backgroundColor: '#ffebee', 
            color: '#c62828',
            borderRadius: '4px',
            marginBottom: '20px'
          }}>
            {error}
          </div>
        )}
        
        {success && (
          <div style={{ 
            padding: '10px', 
            backgroundColor: '#e8f5e9', 
            color: '#2e7d32',
            borderRadius: '4px'
          }}>
            {success}
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadPage;